import {Tooltip} from "primereact/tooltip";
import {type RefObject, useRef} from "react";
import {useTranslation} from "react-i18next";

interface TabHeaderWithTooltipProps {
    i18nPrefix: string;
}

export function TabHeaderWithTooltip({i18nPrefix}: TabHeaderWithTooltipProps) {
    const {t} = useTranslation();
    const ref = useRef<HTMLSpanElement>(null);
    return (
        <>
            <span ref={ref} className="tabViewTitle">
                {t(`${i18nPrefix}.title`)}
            </span>
            <Tooltip target={ref as RefObject<HTMLElement>} className="custom-tooltip">
                {t(`${i18nPrefix}.tooltip`)}
            </Tooltip>
        </>
    );
}
